import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from './ui/Button';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Funciona si mi hijo ya tiene 6 o 7 años?',
    a: 'Sí. Diseñado para niños de 2 a 7 años. Los pasos de comunicación son más efectivos con niños más grandes que ya tienen más lenguaje.'
  }, {
    q: '¿Tengo que leerlo todo antes de aplicarlo?',
    a: 'No. El Capítulo 3 lo lees en 20 minutos y ya tienes lo esencial para aplicar hoy mismo.'
  }, {
    q: '¿Y si yo también exploto fácil?',
    a: 'El protocolo incluye una sección específica para gestionar tu propio estado interno antes de intervenir. No asume que llegas calmado.'
  }, {
    q: '¿Es un libro largo?',
    a: 'No. 90 minutos o menos. Cada capítulo termina con checklist de aplicación inmediata.'
  }, {
    q: '¿Solo sirve para madres?',
    a: 'No. Para madres, padres, abuelos y cualquier cuidador de niños de 2 a 7 años.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tienes 7 días de garantía total. Te devolvemos el dinero sin preguntas.'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-6 bg-white" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <FadeIn data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-33">
            Preguntas frecuentes
          </h2>
          <p className="text-center text-gray-600 mb-12 text-lg" data-id="element-34">
            Todo lo que necesitas saber antes de decidir
          </p>
        </FadeIn>

        <div className="space-y-4 mb-16" data-id="element-35">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-36">
              <div className="border-2 border-gray-200 rounded-2xl overflow-hidden bg-white" data-id="element-37">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-38">
                  <span className="font-bold text-lg text-gray-900 pr-8" data-id="element-39">
                    ❓ {faq.q}
                  </span>
                  {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-orange flex-shrink-0" data-id="element-40" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-41" />}
                </button>
                <AnimatePresence data-id="element-42">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-43">
                      <div className="px-6 pb-5 pt-2 text-gray-700 leading-relaxed border-t-2 border-gray-100 bg-gray-50" data-id="element-44">
                        <span className="font-medium text-brand-sage" data-id="element-45">✅</span>{' '}
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-46">
          <div className="bg-brand-bg p-10 rounded-3xl border-2 border-gray-200 text-center" data-id="element-47">
            <h3 className="text-2xl font-bold mb-6" data-id="element-48">
              ¿Lista para dejar de improvisar?
            </h3>
            <Button onClick={scrollToPricing} className="mb-6 w-full md:w-auto" data-id="element-49">
              👉 DESCARGAR PROTOCOLO CALMA 3 MINUTOS
            </Button>
            <div className="space-y-2 text-sm text-gray-600" data-id="element-50">
              <p className="flex items-center justify-center gap-2" data-id="element-51">
                <span data-id="element-52">📥</span> Descarga instantánea en PDF
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-53">
                <span data-id="element-54">📱</span> Compatible con celular, tablet y computadora
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-55">
                <span data-id="element-56">🔒</span> Pago 100% seguro
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-57">
                <span data-id="element-58">✅</span> Sin suscripciones ni cargos ocultos
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}